import { PageHero } from "../components/PageHero";
import { Reveal } from "../components/Reveal";
import { CompanyCard } from "../components/CompanyCard";
import { useLang } from "../context/LanguageContext";
import { EXTRA } from "../content/extra";
import { PRIVACY_EXTRA } from "../content/legalInfo";

const HERO_IMG = "https://static.prod-images.emergentagent.com/jobs/aac30769-f491-4e91-84b6-42abbea5b108/images/480ed47abb8837de4d45868c027f49c82d0159dab0458873a2209c646b6a7ef8.jpeg";

export default function Privacy() {
  const { lang } = useLang();
  const pr = EXTRA[lang].privacy;
  const extra = PRIVACY_EXTRA[lang] || PRIVACY_EXTRA.sk;
  const sections = [...pr.sections.slice(0, -1), ...extra, pr.sections[pr.sections.length - 1]];

  return (
    <div data-testid="privacy-page">
      <PageHero overline={pr.overline} title={pr.title} subtitle={pr.updated} image={HERO_IMG} />

      <section className="relative z-10 py-20 md:py-28 bg-[#050505]">
        <div className="max-w-3xl mx-auto px-6">
          <div className="space-y-10">
            {sections.map((s, i) => (
              <Reveal key={i} delay={i * 0.04}>
                <div>
                  <h2 className="font-display text-2xl md:text-3xl mb-3 text-[#F2E3C6]">{s.heading}</h2>
                  <p className="text-white/60 leading-relaxed">{s.body}</p>
                </div>
              </Reveal>
            ))}
          </div>

          <Reveal>
            <div className="mt-16">
              <CompanyCard />
            </div>
          </Reveal>
        </div>
      </section>
    </div>
  );
}
